import React, { forwardRef, useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { DEBOUNCE_ACTION_TIME } from '../../constants/defaults'
import InlineSearch, {
  InlineSearchHandle,
  InlineSearchProps,
} from './InlineSearch'

export interface DebouncedInlineSearchProps
  extends Omit<InlineSearchProps, 'search' | 'onClearSearch'> {
  readonly initialValue?: string
}

const DebouncedInlineSearch = forwardRef<
InlineSearchHandle,
DebouncedInlineSearchProps
>(function DebouncedInlineSearch(
  { onChange, initialValue: initialValueProp, ...rest },
  ref,
) {
  const [rawSearchTerm, setRawSearchTerm] = useState(initialValueProp ?? '')

  const [searchTerm] = useDebounce(rawSearchTerm, DEBOUNCE_ACTION_TIME)

  useEffect(() => {
    onChange(searchTerm?.trim())
  }, [searchTerm])

  return (
    <InlineSearch
      ref={ref}
      search={rawSearchTerm}
      onChange={setRawSearchTerm}
      onClearSearch={() => {
        setRawSearchTerm('')
        onChange('')
      }}
      {...rest}
    />
  )
})

export default DebouncedInlineSearch
